import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    token: localStorage.getItem('token'),
    refreshToken: localStorage.getItem('refreshToken'),
    isAuthenticated: !!localStorage.getItem('token'),
};
const adminAuthSlice = createSlice({
    name: 'adminAuth',
    initialState,
    reducers: {
        loginSuccess(state, action) {
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.isAuthenticated = true;
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('refreshToken', action.payload.refreshToken);
        },
        logout(state) {
            state.token = null;
            state.refreshToken = null;
            state.isAuthenticated = false;
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
        },
    },
    selectors: {
        selectIsAuthenticated: (state) => state.isAuthenticated,
        selectToken: (state) => state.token,
        selectRefreshToken: (state) => state.refreshToken,
    },
});
export const { loginSuccess, logout } = adminAuthSlice.actions;
export const { selectIsAuthenticated, selectToken, selectRefreshToken } = adminAuthSlice.selectors;
export default adminAuthSlice.reducer;
